import type { SurfaceFeedFilters, SurfaceTab } from "./types";

/**
 * Feature-local query-key factory (Files pattern).
 * Hierarchy: all → board(slug) → progress|feed|tags|filterTags|asset
 */
export const promoteSurfaceKeys = {
  all: ["promoteSurface"] as const,

  board: (slug: string) => [...promoteSurfaceKeys.all, slug] as const,

  progress: (slug: string) => [...promoteSurfaceKeys.board(slug), "progress"] as const,

  feed: (slug: string, tab: SurfaceTab, filters?: SurfaceFeedFilters) =>
    [
      ...promoteSurfaceKeys.board(slug),
      "feed",
      tab,
      {
        tagIds: filters?.tagIds ?? [],
        excludeTagIds: filters?.excludeTagIds ?? [],
        taskId: filters?.taskId ?? null,
      },
    ] as const,

  solutionTags: (slug: string) => [...promoteSurfaceKeys.board(slug), "solutionTags"] as const,

  filterTags: (slug: string) => [...promoteSurfaceKeys.board(slug), "filterTags"] as const,

  asset: (slug: string, assetId: number) =>
    [...promoteSurfaceKeys.board(slug), "asset", assetId] as const,
} as const;
